import { useEnterprises } from '../../common/contexts/enterprises';
import { useConfiguration } from '../../common/contexts/Configuration';

export interface State {
  ready: boolean;
  sharedWith: string;
}

const useSharedWith = (): State => {
  const { activeEnterprise } = useEnterprises();
  const {
    settings,
    loading: loadingSettings,
    loadingError
  } = useConfiguration();

  const defaultSharedWith = activeEnterprise
    ? `enterprise:${activeEnterprise.id}`
    : 'anyone';

  const getSharedWithFromSettings = (): string | void => {
    if (settings?.general?.sharedReportAccessControl) {
      const { sharedReportAccessControl } = settings.general;

      if (
        activeEnterprise &&
        sharedReportAccessControl.value === 'enterprise'
      ) {
        return `enterprise:${activeEnterprise.id}`;
      }
      return sharedReportAccessControl.value;
    }
  };

  const sharedWithFromSettings = getSharedWithFromSettings();

  return {
    ready: !loadingSettings && !loadingError,
    sharedWith: sharedWithFromSettings || defaultSharedWith
  };
};

export default useSharedWith;
